// OpenUI's dev inspector auto-mounts on first load and fetches from a CDN; this flag, raised from
// router.tsx's first import, keeps it off.
Reflect.set(globalThis, Symbol.for("openui.devtools.autoMount"), true);
